// extracted by mini-css-extract-plugin
export var root = "USBD";
export var rootIcon = "_9WgH";